import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import React, { useState, useEffect } from "react";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import apis from "../../../context/api";

// eslint-disable-next-line react/prop-types
function UserEdit({ id, onSuccess, onCancel }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [userData, setUserData] = useState({
    id: null,
    name: "",
    email: "",
    role: "",
    address: "",
    mobile: "",
  });
  const validateFields = () => {
    const newErrors = {};
    if (!userData.name.trim()) newErrors.name = "Name is required";
    if (!userData.email.trim()) newErrors.email = "Email is required";
    if (!userData.role.trim()) newErrors.role = "Role is required";
    if (!userData.mobile.trim()) newErrors.mobile = "Mobile is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // returns true if no errors
  };
  useEffect(() => {
    if (!id) {
      setUserData({
        id: null,
        name: "",
        email: "",
        role: "",
        address: "",
        mobile: "",
      });
      setLoading(false);
      return;
    }
    apis
      .getUserById(id)
      .then((data) => {
        setUserData(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id, onSuccess]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const updateUser = () => {
    apis
      .updateUserById(id, userData)
      .then((data) => {
        setLoading(false);
        if (onSuccess) {
          onSuccess(userData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const createUser = () => {
    apis
      .createUser(userData)
      .then((data) => {
        setLoading(false);
        if (onSuccess) {
          onSuccess(userData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFields()) {
      return;
    }
    if (id) {
      updateUser();
    } else {
      createUser();
    }
  };
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <MDBox pt={6} pb={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox p={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Name"
                    name="name"
                    variant="outlined"
                    value={userData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Email"
                    name="email"
                    variant="outlined"
                    value={userData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Role"
                    name="role"
                    variant="outlined"
                    value={userData.role}
                    onChange={handleChange}
                    error={!!errors.role}
                    helperText={errors.role}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    type="number"
                    label="Mobile"
                    name="mobile"
                    variant="outlined"
                    value={userData.mobile}
                    onChange={handleChange}
                    error={!!errors.mobile}
                    helperText={errors.mobile}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Address"
                    multiline={true}
                    rows={2}
                    name="address"
                    variant="outlined"
                    value={userData.address}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                pt={4}
                spacing={1}
                display="flex"
                flexWrap="nowrap"
              >
                <Grid item pl={2} pr={2} xs="auto">
                  <MDButton variant="gradient" color="warning" onClick={handleCancel}>
                    Cancel
                  </MDButton>
                </Grid>
                <Grid item xs="auto">
                  <MDButton variant="gradient" color="info" onClick={handleSubmit}>
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
              {error && (
                <MDBox mt={2} color="error">
                  <strong>{error}</strong>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default UserEdit;
